import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Label, Color } from 'ng2-charts';
import { DashboardService } from 'src/app/dashboard.service';
import {ReportService} from '../../services/report/report.service';
import { CompanyService } from '../../services/Company/company.service';
import { OthersService} from '../../services/others/others.service';



//const dataColor1 = 'rgba(117,54,230,0.9)';
//const dataColor2 = 'rgba(255,64,129, 0.7)';
//const dataColor3 = 'rgba(104,218,221,1)';
const dataColor1 = '#93E8F1';
const dataColor2 = '#F39FC9';
const dataColor3 = '#85DAB1';


@Component({
  selector: 'app-brand-card-analytics-widget',
  templateUrl: './brand-card-analytics-widget.component.html',
  styleUrls: ['./brand-card-analytics-widget.component.scss']
})
export class BrandCardAnalyticsWidgetComponent implements OnInit {
  public lineChartData: ChartDataSets[] = [
    {
      data: [0,0,0,0,0,0,0,0,0],
      label: "Shared",
      borderColor: dataColor1,
      backgroundColor: dataColor1,
      pointBackgroundColor: dataColor1,
      pointBorderColor: dataColor1,
      borderWidth: 1,
      pointBorderWidth: 1,
      pointRadius: 0,
      pointHitRadius: 30,
      fill: false,
    }, {
      label: "Exchanges",
      data: [0,0,0,0,0,0,0,0,0],
      backgroundColor: dataColor2,
      borderColor: dataColor2,
      pointBackgroundColor: dataColor2,
      pointBorderColor: dataColor2,
      borderWidth: 1,
      pointBorderWidth: 1,
      pointRadius: 0,
      pointHitRadius: 30,
      fill: false,
    }/*, {
      label: "Echo",
      data: [64, 54, 60, 65, 52, 85, 48],
      borderColor: dataColor3,
      backgroundColor: dataColor3,
      pointBackgroundColor: dataColor3,
      pointBorderColor: dataColor3,
      borderWidth: 1,
      pointBorderWidth: 1,
      pointRadius: 0,
      pointHitRadius: 30,
      fill: false,
    }*/,
  ];
  public lineChartLabels: Label[] = Array.from({ length: 24 }, (v, i) => (i).toString().padStart(2, '0'));//["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  //public lineChartLabels: Label[] = ['0','1','2','3','4','5','6','7','8'];

  
  public lineChartOptions: (ChartOptions & { annotation?: any }) = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        ticks: {
          fontColor: "#CFCFCF",
          stepSize: 1,
          beginAtZero: true
        },
        gridLines: {
          display: false,
        },
      }],
      yAxes: [{
        ticks: {
          fontColor: "#CFCFCF",
        },
      }],
    },
    legend: {
      labels: {
        fontColor: "#CFCFCF",
        boxWidth: 12
      }
    },
  };
  public lineChartLegend = true;
  public lineChartType = 'line';
  public lineChartPlugins = [];
  public active: 'today' | 'thisWeek' | 'thisMonth' = 'today';
  currentCompany;

  statdata:any = {};
  statExchange:any = {};


  constructor(private dashboardService: DashboardService,
    private reportService:ReportService,
    private companyService:CompanyService,
    private otherService:OthersService) {

      this.currentCompany = companyService.getCurrentCompany();

      //alert(this.active)

   
    }

  ngOnInit(): void {
    if (this.currentCompany) {
      let role_id = this.currentCompany.role_id;
      if (role_id == 1 || role_id == 2 || role_id == 4) {
          
          this.getBrandCardAnalytics();
      }
    }
    else {
      
      this.otherService.currentComp$.subscribe(res => {
        //console.log("TTTT123=== " + JSON.stringify(res));
        //this.staff = res;
        //this.fillForm();
        //alert("I am here too")
        if (res) {
          this.currentCompany = res;
          let role_id = this.currentCompany.role_id;

          if (role_id == 1 || role_id == 2 || role_id == 4) {
            this.getBrandCardAnalytics();
          }
          
        }
        
      });
    }
  }

  getBrandCardAnalytics() {
    /*this.dashboardService.getStatistic()
      .subscribe(statistic => {
        this.lineChartData[0].data = statistic.brandCardAnalytics[this.active][0];
        this.lineChartData[1].data = statistic.brandCardAnalytics[this.active][1];
        this.lineChartData[2].data = statistic.brandCardAnalytics[this.active][2];
      });*/

      this.reportService.getComCardStats(this.currentCompany.id).then((res:any)=>{
          
          if (res.status == 'OK') {
            this.statdata = res.data;
             this.processExchangeStats(res.data);
          }
      });


      this.reportService.getCardSharingStats(this.currentCompany.id).then((res:any)=>{
        //console.log("C=" + JSON.stringify(res));
          if (res.status=="OK") {
            this.statExchange = res.data;
            this.processSharingStats(res.data);
          }
      });
  }

  processExchangeStats(data:any) {

      if (data) {

      let row = data[this.active];

      let totals = [],labels=[];
      if (row) {
      for(let m of row) {
          totals.push(m.total);
          if (this.active == 'thisWeek') {
          labels.push(m.date);
          }
      }
    }

      if (this.active == 'thisWeek') {
        //this.lineChartLabels = labels;
      }
      //console.log(totals);

      this.lineChartData[1].data = totals;
    }

  }


  processSharingStats(data:any) {

    if (data) {

    let row = data[this.active];

    let totals = [];
    //if (row && row.length>0){
    for(let m of row) {
        totals.push(m.total);
    //}
  }

    //console.log(totals);

    this.lineChartData[0].data = totals;
  }

}

  onChange(active: 'today' | 'thisWeek' | 'thisMonth') {
    this.active = active;

    if (active === 'thisMonth') {
      this.lineChartLabels = Array.from({ length: 30 }, (v, i) => (i + 1).toString());
    } else if (active === 'thisWeek') {
      this.lineChartLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    } else {
      this.lineChartLabels = Array.from({ length: 24 }, (v, i) => (i).toString().padStart(2, '0'));
    }
    //this.getBrandCardAnalytics();
    this.processExchangeStats(this.statdata);
    this.processSharingStats(this.statExchange);

  }

}
